import { useState } from 'react'
import numeral from 'numeral'

import Image from 'next/image'
import Text from '/src/components/@common.blocks/Text'
import Grid from '/src/components/@common.blocks/Grid'
import Skeleton from '/src/components/@common.blocks/Skeleton'
import blockchainIcons from '/src/constants/blockchainIcons'

const ImagePlaceholder = ({ logo, name }) => {
  return (
    <div className='asset-placeholder'>
      <div />
      <img className='asset-placeholder__logo' src={logo} alt={name} />
    </div>
  )
}

const AssetCard = ({
  image,
  logo,
  title,
  loading,
  rank,
  price,
  owner,
  isFaves,
  footer = false,
  onClick,
  blockchain = 'ethereum',
}) => {
  const [imageLoading, setImageLoading] = useState(!!image)
  const className = 'asset-card'
  return (
    <article className={className} onClick={onClick}>
      {isFaves && (
        <div className='asset-card__favorite'>
          <img src='/ui-icons/heart.svg' alt='favorite' />
        </div>
      )}
      <div className='asset-card__cover'>
        <Skeleton loading={imageLoading || loading}>
          {image && (
            <Image
              src={image}
              alt={title}
              layout='fill'
              onLoadingComplete={() => setImageLoading(false)}
            />
          )}
          {!image && <ImagePlaceholder name={title} logo={logo} />}
        </Skeleton>
      </div>
      <div className='asset-card__container'>
        <header className='asset-card__header'>
          {loading && <div className='asset-card__skeleton' />}
          {!loading && (
            <>
              <h3 className='text text_size_md text_color_secondary text_weight_bold'>
                {`Rank #${rank}`}
              </h3>
              <Text weight='bold'>{title}</Text>
            </>
          )}
        </header>
        {footer && (
          <footer className='grid g-gutter-1 asset-card__footer'>
            {loading && <div className='asset-card__skeleton' />}
            {!loading && (
              <>
                <Grid.Col xs={8} sm={8}>
                  <Text size='sm' color='light-gray'>
                    {owner || '--'}
                  </Text>
                </Grid.Col>
                {price && (
                  <Grid.Col xs={4} sm={4}>
                    <div className='asset-card__footer-buy'>
                      <Image
                        src={blockchainIcons[blockchain]}
                        alt={blockchain}
                        width={14}
                        height={14}
                      />
                      <Text size='sm' color='light-gray'>
                        {numeral(price).format('0.[0]a')}
                      </Text>
                    </div>
                  </Grid.Col>
                )}
              </>
            )}
          </footer>
        )}
      </div>
    </article>
  )
}

export default AssetCard
